import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StorageModule } from '@ngx-pwa/local-storage';
import { NgMaterialModule } from '@principle-theorem/ng-material';
import { NgSharedModule, PipesModule } from '@principle-theorem/ng-shared';
import { LoginComponent } from './login/login.component';
import { WorkspaceSelectorComponent } from './workspace-selector/workspace-selector.component';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { FlexLayoutModule } from 'ng-flex-layout';
import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import { NgxAuthFirebaseuiRegisterComponent } from './ngx-auth-firebaseui-register/ngx-auth-firebaseui-register.component';
import { NgxAuthFirebaseuiLoginComponent } from './ngx-auth-firebaseui-login/ngx-auth-firebaseui-login.component';
import { LegalityDialogComponent } from './legality-dialog/legality-dialog.component';
import { EmailConfirmationComponent } from './email-confirmation/email-confirmation.component';
import { AuthProvidersComponent } from './auth-providers/auth-providers.component';
import { AuthComponent } from './ngx-auth-firebaseui/auth.component';
import {
  INgAuthConfig,
  NG_AUTH_CONFIG_TOKEN,
  ngAuthConfigFactory,
  USER_PROVIDED_CONFIG_TOKEN,
} from './ngx-auth-firebaseui-old/module-config';
import { RouterModule } from '@angular/router';
import { RegisterComponent } from './register/register.component';
import { SignInComponent } from './sign-in/sign-in.component';
import { PasswordlessLoginComponent } from './passwordless-login/passwordless-login.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgMaterialModule,
    NgSharedModule,
    StorageModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    FormsModule,
    MatPasswordStrengthModule,
    PipesModule,
    PasswordlessLoginComponent,
  ],
  declarations: [
    LoginComponent,
    WorkspaceSelectorComponent,
    RegisterComponent,
    SignInComponent,
    AuthComponent,
    AuthProvidersComponent,
    EmailConfirmationComponent,
    LegalityDialogComponent,
    NgxAuthFirebaseuiLoginComponent,
    NgxAuthFirebaseuiRegisterComponent,
  ],
  exports: [
    LoginComponent,
    WorkspaceSelectorComponent,
    RegisterComponent,
    SignInComponent,
    PasswordlessLoginComponent,
  ],
})
export class NgAuthModule {
  constructor(
    private _iconRegistry: MatIconRegistry,
    private _sanitizer: DomSanitizer
  ) {
    this.registerProviderIcons();
  }

  static forRoot(
    config: INgAuthConfig = {}
  ): ModuleWithProviders<NgAuthModule> {
    return {
      ngModule: NgAuthModule,
      providers: [
        { provide: USER_PROVIDED_CONFIG_TOKEN, useValue: config },
        {
          provide: NG_AUTH_CONFIG_TOKEN,
          useFactory: ngAuthConfigFactory,
          deps: [USER_PROVIDED_CONFIG_TOKEN],
        },
      ],
    };
  }

  registerProviderIcons(): void {
    this._iconRegistry
      .addSvgIcon(
        'google',
        this._sanitizer.bypassSecurityTrustResourceUrl('/assets/mdi/google.svg')
      )
      .addSvgIcon(
        'apple',
        this._sanitizer.bypassSecurityTrustResourceUrl('/assets/mdi/apple.svg')
      )
      .addSvgIcon(
        'google-colored',
        this._sanitizer.bypassSecurityTrustResourceUrl('/assets/google.svg')
      )
      .addSvgIcon(
        'facebook',
        this._sanitizer.bypassSecurityTrustResourceUrl(
          '/assets/mdi/facebook.svg'
        )
      )
      .addSvgIcon(
        'twitter',
        this._sanitizer.bypassSecurityTrustResourceUrl(
          '/assets/mdi/twitter.svg'
        )
      )
      .addSvgIcon(
        'github',
        this._sanitizer.bypassSecurityTrustResourceUrl(
          '/assets/mdi/github-circle.svg'
        )
      )
      .addSvgIcon(
        'microsoft',
        this._sanitizer.bypassSecurityTrustResourceUrl(
          '/assets/mdi/microsoft.svg'
        )
      )
      .addSvgIcon(
        'yahoo',
        this._sanitizer.bypassSecurityTrustResourceUrl('/assets/mdi/yahoo.svg')
      )
      .addSvgIcon(
        'phone',
        this._sanitizer.bypassSecurityTrustResourceUrl('/assets/phone.svg')
      );
  }
}
